import { useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import { loginRequest } from "../../../../utils/authConfig";

export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup(loginRequest);
    };

    return (
        <Button
            onClick={handleLogin}
            color="inherit"
        >
            Login
        </Button>
    );
};